import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_Rail } from '../../../lib/data/standard-weight';

const RailForm = ({ onSaveStructure, onChangeWeightSummary, rails }) => {
    const [isShow, setIsShow] = useState(rails?.length || false);
    const [newRail, setNewRail] = useState(rails || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [typeCategory, setTypeCategory] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [length, setLength] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totallength, setTotallength] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* Category 설명하는 text */
    // const typeCategoryText = useRef({
    //     0: 'V-Type',
    //     1: 'I-Type',
    // });

    /*  처음 props로 넘어온 rails를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialinternalBeltCleaner = useRef(rails || []);

    /* 벨트폭에 해당하는 Weight를 가져온다. */
    useEffect(() => {
        if (!standardWeight_Rail || !typeCategory) {
            return;
        }

        const library = standardWeight_Rail.find((item) => item.type === typeCategory);
        if (!library) {
            alert('Check Belt Width!');
            return;
        }

        setStandardWeight(library.standardWeight);
    }, [typeCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!standardWeight || !factor) {
        //     return;
        // }
        const _unitWeight = Math.ceil(standardWeight * factor);
        setUnitWeight(Math.ceil(_unitWeight));
    }, [factor, standardWeight]);

    /* 중량 계산 */
    useEffect(() => {
        // if (!unitWeight || !length) {
        //     return;
        // }
        const _weight = Math.ceil(2 * unitWeight * length); // travelling length * 2
        setWeight(_weight);
    }, [length, unitWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newRail.length) {
            return 0;
        }
        return Math.max(...newRail.map((item) => Number(item.id.substring(3))), 0);
    }, [newRail]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`RL-${getLastId() * 1 + 1}`);
        // setLength('');
        // setStandardWeight('');
        // setFactor('');
        setLength('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotallength = useCallback((items) => {
        const _totallength = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.length);
        }, 0);
        setTotallength(_totallength);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newRail에 internalBeltCleaner 추가 */
    const onAddInternalBeltCleaner = useCallback(() => {
        if (!length || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const internalBeltCleaner = {
            id,
            railType: typeCategory,
            standardWeight,
            factor,
            length,
            unitWeight,
            weight,
        };
        setNewRail((prev) => [...prev, internalBeltCleaner]);
        setIsChanged(true);
    }, [id, typeCategory, standardWeight, factor, length, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 internalBeltCleaner 삭제 */
    const onDeleteInternalBeltCleaner = useCallback((id) => {
        setNewRail((prev) => prev.filter((item) => item.id !== id));
        setIsChanged(true);
    }, []);

    /* newRail에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotallength(newRail);
        getTotalWeight(newRail);
        initializeForm();
        onSaveStructure({
            key: 'rail',
            value: newRail,
        });
        onChangeWeightSummary({
            key: 'rail',
            value: {
                totallength,
                totalWeight,
            },
        });
    }, [
        getTotallength,
        getTotalWeight,
        initializeForm,
        newRail,
        onChangeWeightSummary,
        onSaveStructure,
        totallength,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveInternalBeltCleaner = useCallback(() => {
    //     onSaveStructure({
    //         key: 'rail',
    //         value: newRail,
    //     });
    //     onChangeWeightSummary({
    //         key: 'rail',
    //         value: {
    //             totallength,
    //             totalWeight,
    //         },
    //     });
    // }, [newRail, onChangeWeightSummary, onSaveStructure, totallength, totalWeight]);

    /* 변경 사항을 취소하면 newRail를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewRail(initialinternalBeltCleaner.current);
    //     onSaveStructure({
    //         key: 'rail',
    //         value: initialinternalBeltCleaner.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'rail',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <RailFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Rail for Tripper/Shuttle</h3>
                <div style={{ width: '120px' }}>Q'ty: {totallength} m</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>Type</th>
                                <th>
                                    Standard W't
                                    <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    단위중량
                                    <br />
                                    (kg/m)
                                </th>
                                <th>
                                    Travelling
                                    <br />
                                    Length(m)
                                </th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newRail &&
                                newRail.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.railType}</td>
                                        <td>{item.standardWeight}</td>
                                        <td>{item.factor}</td>
                                        <td>{item.unitWeight}</td>
                                        <td>{item.length}</td>
                                        <td>{item.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteInternalBeltCleaner(item.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td className="td-radio">
                                    <div className="input-radio">
                                        <select onChange={(e) => setTypeCategory(e.target.value)}>
                                            <option value="" selected disabled>
                                                Rail Selection
                                            </option>
                                            <option value="6">6</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                            <option value="12">12</option>
                                            <option value="15">15</option>
                                            <option value="22">22</option>
                                            <option value="30A">30A</option>
                                            <option value="73A">37A</option>
                                            <option value="40N">40N</option>
                                            <option value="50N">50N</option>
                                            <option value="60">60</option>
                                        </select>
                                    </div>
                                </td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddInternalBeltCleaner}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>Rail for Shuttle / Tripper Total</td>
                                <td>{totallength}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveInternalBeltCleaner} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </RailFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const RailFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        margin: 0 auto;
    }
    .input-radio {
        // display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-left: 1rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default RailForm;
